import React, { useState, useEffect } from "react";

function Orders() {
  const [orders, setOrders] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    customerName: "",
    customerPhone: "",
    description: "",
    category: "",
    weightEstimate: "",
    purity: "",
    advancePaid: "",
    totalEstimate: "",
    dueDate: "",
    notes: "",
    karigar: "",
  });

  const statusSteps = [
    "Ordered",
    "Designing and Casting",
    "Finishing",
    "Ready",
    "Delivered",
  ];

  useEffect(() => {
    fetch(`/api/orders?userId=${parseInt(localStorage.getItem("userId"))}`)
      .then((r) => r.json())
      .then((d) => setOrders(d));
  }, []);

  const saveOrder = () => {
    fetch(`/api/orders?userId=${parseInt(localStorage.getItem("userId"))}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        weightEstimate: parseFloat(form.weightEstimate),
        advancePaid: parseFloat(form.advancePaid),
        totalEstimate: parseFloat(form.totalEstimate),
      }),
    })
      .then((r) => r.json())
      .then((d) => {
        setOrders([...orders, d]);
        setShowForm(false);
        setForm({
          customerName: "",
          customerPhone: "",
          description: "",
          category: "",
          weightEstimate: "",
          purity: "",
          advancePaid: "",
          totalEstimate: "",
          dueDate: "",
          notes: "",
          karigar: "",
        });
      });
  };

  const updateStatus = (id, status) => {
    fetch(`/api/orders/${id}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    })
      .then((r) => r.json())
      .then((updated) =>
        setOrders(orders.map((o) => (o.id === id ? updated : o))),
      );
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "13px",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        color: "#403301",
        background: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Orders</h2>
          <p style={{ margin: 0, color: "#856A00", fontSize: "12px" }}>
            {orders.length} orders
          </p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: "#856A00",
            color: "gold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          + New Order
        </button>
      </div>

      {/* New Order Form */}
      {showForm && (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <h3 style={{ marginTop: 0, color: "#403301" }}>New Order</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "12px",
            }}
          >
            <div>
              <label style={labelStyle}>Customer Name</label>
              <input
                placeholder="Meera Sharma"
                value={form.customerName}
                onChange={(e) =>
                  setForm({ ...form, customerName: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Phone</label>
              <input
                placeholder="98XX XXXXXX"
                value={form.customerPhone}
                onChange={(e) =>
                  setForm({ ...form, customerPhone: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Category</label>
              <select
                value={form.category}
                onChange={(e) =>
                  setForm({ ...form, category: e.target.value, purity: "" })
                }
                style={inputStyle}
              >
                <option value="">Select</option>
                <option>Gold</option>
                <option>Silver</option>
                <option>Diamond</option>
                <option>Other</option>
              </select>
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={labelStyle}>Description</label>
              <input
                placeholder="Custom bridal necklace set"
                value={form.description}
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            {(form.category === "Gold" ||
              form.category === "Silver" ||
              form.category === "Diamond") && (
              <div>
                <label style={labelStyle}>
                  {form.category === "Diamond" ? "Carat" : "Purity"}
                </label>
                <input
                  type="text"
                  placeholder={
                    form.category === "Gold"
                      ? "e.g. 22K, 24K, 18K"
                      : form.category === "Silver"
                        ? "e.g. 925, 999, 800"
                        : "e.g. 0.5, 1.0, 2.5"
                  }
                  value={form.purity}
                  onChange={(e) => setForm({ ...form, purity: e.target.value })}
                  style={inputStyle}
                />
              </div>
            )}
            <div>
              <label style={labelStyle}>Weight Estimate (g)</label>
              <input
                type="number"
                placeholder="12.5"
                value={form.weightEstimate}
                onChange={(e) =>
                  setForm({ ...form, weightEstimate: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Total Estimate (₹)</label>
              <input
                type="number"
                placeholder="85000"
                value={form.totalEstimate}
                onChange={(e) =>
                  setForm({ ...form, totalEstimate: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Advance Paid (₹)</label>
              <input
                type="number"
                placeholder="20000"
                value={form.advancePaid}
                onChange={(e) =>
                  setForm({ ...form, advancePaid: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Due Date</label>
              <input
                type="date"
                value={form.dueDate}
                onChange={(e) => setForm({ ...form, dueDate: e.target.value })}
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Karigar (Maker)</label>
              <input
                placeholder="e.g. Ramesh Kumar"
                value={form.karigar}
                onChange={(e) => setForm({ ...form, karigar: e.target.value })}
                style={inputStyle}
              />
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={labelStyle}>Notes</label>
              <input
                placeholder="Any special instructions"
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
            <button
              onClick={saveOrder}
              style={{
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Save Order
            </button>
            <button
              onClick={() => setShowForm(false)}
              style={{
                background: "transparent",
                color: "#403301",
                border: "1px solid #856A00",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Orders List */}
      {orders.length === 0 ? (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "40px",
            textAlign: "center",
            color: "#403301",
          }}
        >
          No orders yet — click + New Order
        </div>
      ) : (
        orders.map((order, i) => (
          <div
            key={i}
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "16px",
              marginBottom: "12px",
            }}
          >
            {/* Order Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <div>
                <span style={{ fontWeight: "bold", color: "#403301" }}>
                  {order.customerName}
                </span>
                <span style={{ color: "#856A00", fontSize: "13px" }}>
                  {" "}
                  — {order.description}
                </span>
              </div>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <span style={{ fontSize: "11px", color: "#403301" }}>
                  {order.orderNumber} · Due{" "}
                  {new Date(order.dueDate).toLocaleDateString("en-IN")}
                </span>
                <span
                  style={{
                    background: "#403301",
                    color: "#efbf04",
                    padding: "2px 8px",
                    borderRadius: "20px",
                    fontSize: "11px",
                  }}
                >
                  {order.status}
                </span>
              </div>
            </div>

            {/* Status Pipeline */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              {statusSteps.map((step, si) => {
                const currentIndex = statusSteps.indexOf(order.status);
                const isDone = si < currentIndex;
                const isActive = si === currentIndex;
                return (
                  <React.Fragment key={si}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          background: isDone
                            ? "#856A00"
                            : isActive
                              ? "#C2B067"
                              : "#403301",
                          border: isActive ? "2px solid #856A00" : "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "10px",
                          color: isDone
                            ? "gold"
                            : isActive
                              ? "#403301"
                              : "#856A00",
                        }}
                      >
                        {isDone ? "✓" : si + 1}
                      </div>
                      <div
                        style={{
                          fontSize: "9px",
                          color: "#403301",
                          marginTop: "4px",
                          textAlign: "center",
                          width: "60px",
                        }}
                      >
                        {step}
                      </div>
                    </div>
                    {si < statusSteps.length - 1 && (
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          background: isDone ? "#856A00" : "#403301",
                          marginBottom: "14px",
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* Order Details + Actions */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "flex",
                  gap: "16px",
                  flexWrap: "wrap",
                }}
              >
                <span>
                  {order.category === "Diamond" ? "Carat" : "Purity"}:{" "}
                  <strong>{order.purity || "-"}</strong>
                </span>
                <span>
                  Weight: <strong>{order.weightEstimate}g</strong>
                </span>
                <span>
                  Advance: <strong>₹{order.advancePaid}</strong>
                </span>
                <span>
                  Total: <strong>₹{order.totalEstimate}</strong>
                </span>
                {order.karigar && (
                  <span>
                    Karigar: <strong>{order.karigar}</strong>
                  </span>
                )}
              </div>
              <div style={{ display: "flex", gap: "6px" }}>
                {statusSteps.indexOf(order.status) > 0 && (
                  <button
                    onClick={() =>
                      updateStatus(
                        order.id,
                        statusSteps[statusSteps.indexOf(order.status) - 1],
                      )
                    }
                    style={{
                      background: "transparent",
                      color: "#403301",
                      border: "1px solid #856A00",
                      padding: "4px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "11px",
                    }}
                  >
                    ← Back
                  </button>
                )}
                {statusSteps.indexOf(order.status) < statusSteps.length - 1 && (
                  <button
                    onClick={() =>
                      updateStatus(
                        order.id,
                        statusSteps[statusSteps.indexOf(order.status) + 1],
                      )
                    }
                    style={{
                      background: "#856A00",
                      color: "gold",
                      border: "none",
                      padding: "4px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "11px",
                    }}
                  >
                    Next →
                  </button>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Orders;
